import React from 'react'
import './Footer.css'
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer" id="contact">
      <div className="box-container" id="footers">
            <div className="box">
                <h3>Locations</h3>
                <p>Ahmedabad</p>
                <p>Surendranagar</p>
                <p>Bhavnagar</p>
                <br/>
               <Link to="/Admin">Admin User Click Here</Link>
            </div>

            <div className="box">
                <h3>Quick Links</h3>
                <p>Home</p>
                <p>Product</p>
                <p>About</p>
                <p>List</p>
            </div>

            <div className="box">
                <h3>Contact Info</h3>
                <p>+91 94*** *****</p>
                <p>+91 94*** *****</p>
                <p>*********@gm**l.com</p>
                <p>Surendranagar, <br></br> Gujarat-000000</p>
            </div>


            <div className="box">
                <h3>Follo Us on</h3>
                <p>Facebook</p>
                <p>Instagram</p>
                <p>Twitter</p>
                <p>Whatsapp</p>
            </div>
        </div>

        <div className="credit">Copyright @2023 by <span>Acharya Web Technologies</span></div>

    </div>
  )
}
